import { useEffect, useState } from 'react';

const STYLE = `
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Space+Mono:wght@400;700&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  html { scroll-behavior: smooth; }
  body { background: #F9F7F4; color: #1a1a1a; font-family: 'Space Mono', monospace; overflow-x: hidden; }

  /* ── NAV — identical to all other pages ── */
  .ct-nav {
    position: fixed; top: 0; left: 0; right: 0; z-index: 999;
    background: #1B2FE8; border-bottom: 4px solid #1a1a1a;
    display: flex; align-items: center; justify-content: space-between;
    padding: 0 40px; height: 64px;
  }
  .ct-nav-logo { font-family: 'Bebas Neue', monospace; font-size: 28px; letter-spacing: 0.1em; color: #FFD600; text-decoration: none; }
  .ct-nav-links { display: flex; gap: 28px; align-items: center; }
  .ct-nav-link { font-family: 'Space Mono', monospace; font-size: 11px; font-weight: 700; letter-spacing: 0.18em; text-transform: uppercase; color: rgba(255,255,255,0.7); text-decoration: none; transition: color 0.2s; }
  .ct-nav-link:hover { color: #FFD600; }
  .ct-nav-link.active { color: #FFD600; }
  .ct-nav-cta { font-family: 'Bebas Neue', monospace; font-size: 16px; letter-spacing: 0.12em; background: #FFD600; color: #1a1a1a; border: 3px solid #1a1a1a; border-radius: 999px; padding: 8px 24px; text-decoration: none; box-shadow: 3px 3px 0 #1a1a1a; transition: transform 0.15s, box-shadow 0.15s; }
  .ct-nav-cta:hover { transform: translateY(-2px); box-shadow: 5px 5px 0 #1a1a1a; }

  /* ── WAVE ── */
  .ct-wave { display: block; width: 100%; overflow: hidden; line-height: 0; margin-top: -3px; margin-bottom: -1px; }
  .ct-wave svg { display: block; width: 100%; }

  /* ── HERO — warm cream, attractive, light ── */
  .ct-hero {
    background: #FFF8EE;
    padding: 130px 40px 90px;
    position: relative; overflow: hidden;
    border-bottom: 1px solid #EDE8DE;
  }
  /* subtle warm dot grid */
  .ct-hero::before {
    content: '';
    position: absolute; inset: 0;
    background-image: radial-gradient(circle, rgba(27,47,232,0.07) 1px, transparent 1px);
    background-size: 24px 24px;
    pointer-events: none;
  }
  /* soft right glow */
  .ct-hero::after {
    content: '';
    position: absolute; top: 0; right: 0; bottom: 0; width: 50%;
    background: radial-gradient(ellipse 70% 80% at 80% 50%, rgba(255,214,0,0.1) 0%, transparent 70%);
    pointer-events: none;
  }
  .ct-hero-inner {
    max-width: 1100px; margin: 0 auto;
    display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center;
    position: relative; z-index: 1;
  }
  .ct-hero-eyebrow { font-family: 'Space Mono', monospace; font-size: 10px; font-weight: 700; letter-spacing: 0.3em; text-transform: uppercase; color: #1B2FE8; margin-bottom: 20px; }
  .ct-hero-title { font-family: 'Bebas Neue', monospace; font-size: clamp(60px,8vw,108px); line-height: 0.92; letter-spacing: 0.01em; color: #1a1a1a; }
  .ct-hero-title em { color: #1B2FE8; font-style: normal; display: block; }
  .ct-hero-desc { font-family: 'Space Mono', monospace; font-size: 11px; line-height: 2; color: #888; margin-top: 24px; max-width: 380px; }

  /* contact pills */
  .ct-hero-pills { display: flex; flex-direction: column; gap: 12px; margin-top: 32px; }
  .ct-pill {
    display: flex; align-items: center; gap: 14px;
    border: 1px solid #EDE8DE; background: #fff;
    padding: 12px 20px; border-radius: 2px;
    box-shadow: 3px 3px 0 #E8E4DC;
    font-family: 'Space Mono', monospace;
    transition: box-shadow 0.15s, transform 0.15s;
  }
  .ct-pill:hover { box-shadow: 5px 5px 0 #1a1a1a; transform: translateY(-2px); }
  .ct-pill-icon { font-size: 18px; flex-shrink: 0; }
  .ct-pill-label { font-size: 9px; font-weight: 700; letter-spacing: 0.18em; text-transform: uppercase; color: #999; line-height: 1; }
  .ct-pill-value { font-size: 11px; font-weight: 700; letter-spacing: 0.06em; color: #1a1a1a; margin-top: 2px; }

  /* ── Campaign Visual (replaces radar) ── */
  .ct-camp-wrap { display:flex; align-items:center; justify-content:center; position:relative; height:360px; }

  /* glow backdrop */
  .ct-camp-glow { position:absolute; width:260px; height:260px; border-radius:50%;
    background:radial-gradient(circle, rgba(27,47,232,0.18) 0%, rgba(255,214,0,0.06) 55%, transparent 75%);
    animation:ct-glow-pulse 4s ease-in-out infinite; }
  @keyframes ct-glow-pulse { 0%,100%{transform:scale(1);opacity:0.7} 50%{transform:scale(1.15);opacity:1} }

  /* central hub card */
  .ct-camp-hub { position:relative; z-index:2; width:130px; height:130px; border-radius:50%;
    background:linear-gradient(135deg,#1B2FE8,#3355FF);
    display:flex; flex-direction:column; align-items:center; justify-content:center;
    box-shadow:0 0 40px rgba(27,47,232,0.5),0 0 80px rgba(27,47,232,0.2);
    animation:ct-hub-pulse 3.5s ease-in-out infinite; }
  @keyframes ct-hub-pulse {
    0%,100%{box-shadow:0 0 40px rgba(27,47,232,0.5),0 0 80px rgba(27,47,232,0.2)}
    50%{box-shadow:0 0 60px rgba(27,47,232,0.7),0 0 110px rgba(27,47,232,0.3)}
  }
  .ct-hub-icon { font-size:34px; }
  .ct-hub-lbl { font-family:'Space Mono',monospace; font-size:7px; font-weight:700; letter-spacing:0.15em; color:rgba(255,255,255,0.7); text-transform:uppercase; margin-top:4px; }

  /* orbit rings */
  .ct-orb-ring { position:absolute; border-radius:50%; border:1.5px dashed; }
  .ct-orb-ring-a { width:240px; height:240px; border-color:rgba(27,47,232,0.25); animation:ct-spin-cw 24s linear infinite; }
  .ct-orb-ring-b { width:340px; height:340px; border-color:rgba(255,214,0,0.15); animation:ct-spin-ccw 32s linear infinite; }
  @keyframes ct-spin-cw  { from{rotate:0deg}  to{rotate:360deg}  }
  @keyframes ct-spin-ccw { from{rotate:0deg}  to{rotate:-360deg} }

  /* platform icon orbiters */
  .ct-orb-icon { position:absolute; z-index:3; }

  /* inner ring orbiters (radius 120) */
  .ct-ow-a { width:240px; height:240px; position:absolute; border-radius:50%; animation:ct-spin-cw 24s linear infinite; }
  .ct-ow-b { width:340px; height:340px; position:absolute; border-radius:50%; animation:ct-spin-ccw 32s linear infinite; }
  .ct-ow-a:nth-child(1) { animation-delay:0s;    }
  .ct-ow-a:nth-child(2) { animation-delay:-8s;   }
  .ct-ow-a:nth-child(3) { animation-delay:-16s;  }

  .ct-orb-chip { position:absolute; top:-18px; left:calc(50% - 18px);
    width:36px; height:36px; border-radius:10px; background:#fff;
    border:1.5px solid #E8E4DC; display:flex; align-items:center; justify-content:center;
    font-size:16px; box-shadow:0 4px 14px rgba(0,0,0,0.1);
    animation:ct-chip-upright 24s linear infinite; }
  .ct-orb-chip-b { position:absolute; top:-18px; left:calc(50% - 18px);
    width:36px; height:36px; border-radius:10px; background:#fff;
    border:1.5px solid #E8E4DC; display:flex; align-items:center; justify-content:center;
    font-size:16px; box-shadow:0 4px 14px rgba(0,0,0,0.1);
    animation:ct-chip-upright-b 32s linear infinite; }
  @keyframes ct-chip-upright   { from{rotate:0deg} to{rotate:-360deg} }
  @keyframes ct-chip-upright-b { from{rotate:0deg} to{rotate:360deg}  }

  /* floating stat badges */
  .ct-camp-badge { position:absolute; z-index:4;
    background:#fff; border:1.5px solid #E8E4DC; border-radius:8px; padding:8px 14px;
    font-family:'Space Mono',monospace; font-size:9px; font-weight:700; color:#1a1a1a;
    white-space:nowrap; box-shadow:0 4px 16px rgba(0,0,0,0.08); letter-spacing:0.06em; }
  .ct-camp-badge b { color:#1B2FE8; }
  .ct-cb-1 { top:4%;  right:0%;  animation:ct-flt-up 4s ease-in-out infinite; }
  .ct-cb-2 { bottom:12%; left:0%; animation:ct-flt-dn 3.5s ease-in-out infinite 0.6s; }
  .ct-cb-3 { bottom:2%;  right:4%;animation:ct-flt-up 3.8s ease-in-out infinite 1.2s; }
  @keyframes ct-flt-up { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-8px)} }
  @keyframes ct-flt-dn { 0%,100%{transform:translateY(0)} 50%{transform:translateY(8px)} }

  /* connecting dashed lines from hub to badges — purely decorative via pseudo */
  .ct-camp-dot { position:absolute; width:8px; height:8px; border-radius:50%; background:#FFD600;
    box-shadow:0 0 8px rgba(255,214,0,0.8); animation:ct-dot-ping 2s ease-in-out infinite; z-index:4; }
  .ct-cd-1 { top:28%; right:18%; animation-delay:0s; }
  .ct-cd-2 { bottom:30%; left:20%; animation-delay:0.7s; }
  .ct-cd-3 { bottom:22%; right:22%; animation-delay:1.4s; }
  @keyframes ct-dot-ping {
    0%,100%{ transform:scale(1); box-shadow:0 0 8px rgba(255,214,0,0.8),0 0 0 0 rgba(255,214,0,0.4); }
    50%    { transform:scale(1.3); box-shadow:0 0 14px rgba(255,214,0,1),0 0 0 8px rgba(255,214,0,0); }
  }

  /* ── MARQUEE ── */
  .ct-marquee-bar { background: #0E0E10; padding: 13px 0; overflow: hidden; white-space: nowrap; border-top: 1px solid rgba(255,214,0,0.12); border-bottom: 1px solid rgba(255,214,0,0.12); }
  .ct-marquee-track { display: inline-flex; animation: ct-mq 24s linear infinite; }
  .ct-mq-item { font-family: 'Space Mono', monospace; font-size: 10px; font-weight: 700; letter-spacing: 0.22em; color: rgba(255,255,255,0.35); padding: 0 32px; display: flex; align-items: center; gap: 16px; text-transform: uppercase; transition: color 0.2s, text-shadow 0.2s; cursor: default; }
  .ct-mq-item:hover { color: #FFD600; text-shadow: 0 0 10px rgba(255,214,0,0.9), 0 0 24px rgba(255,214,0,0.5); }
  .ct-mq-dot { display: inline-block; width: 4px; height: 4px; background: #FFD600; border-radius: 50%; flex-shrink: 0; }
  @keyframes ct-mq { from{transform:translateX(0)} to{transform:translateX(-50%)} }

  /* ── CONTACT CARDS ── */
  .ct-cards-section { background: #F9F7F4; padding: 80px 40px; border-bottom: 1px solid #E8E4DC; }
  .ct-cards-inner { max-width: 1100px; margin: 0 auto; }
  .ct-cards-grid { display: grid; grid-template-columns: repeat(4,1fr); gap: 1px; background: #E8E4DC; border: 1px solid #E8E4DC; }
  .ct-card { background: #F9F7F4; padding: 36px 24px; transition: background 0.2s; cursor: default; }
  .ct-card:hover { background: #fff; }
  .ct-card-icon { font-size: 28px; margin-bottom: 16px; display: block; }
  .ct-card-title { font-family: 'Bebas Neue', monospace; font-size: 22px; letter-spacing: 0.04em; color: #1a1a1a; margin-bottom: 8px; }
  .ct-card-value { font-family: 'Space Mono', monospace; font-size: 10px; font-weight: 700; letter-spacing: 0.08em; color: #1B2FE8; margin-bottom: 6px; }
  .ct-card-note { font-family: 'Space Mono', monospace; font-size: 9px; letter-spacing: 0.08em; color: #bbb; line-height: 1.7; }

  /* ── FORM + MAP ── */
  .ct-form-section { background: #F9F7F4; padding: 80px 40px 100px; }
  .ct-form-inner { max-width: 1100px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 60px; align-items: start; }

  /* form */
  .ct-form-eyebrow { font-family: 'Space Mono', monospace; font-size: 10px; font-weight: 700; letter-spacing: 0.3em; text-transform: uppercase; color: #999; margin-bottom: 16px; }
  .ct-form-title { font-family: 'Bebas Neue', monospace; font-size: clamp(36px,4vw,56px); letter-spacing: 0.02em; color: #1a1a1a; line-height: 1; margin-bottom: 36px; }
  .ct-form-title em { color: #1B2FE8; font-style: normal; }
  .ct-field { margin-bottom: 20px; }
  .ct-label { font-family: 'Space Mono', monospace; font-size: 9px; font-weight: 700; letter-spacing: 0.2em; text-transform: uppercase; color: #999; display: block; margin-bottom: 8px; }
  .ct-input {
    width: 100%; font-family: 'Space Mono', monospace; font-size: 11px; letter-spacing: 0.06em;
    background: #fff; border: 1px solid #E8E4DC; border-radius: 0; padding: 13px 16px;
    color: #1a1a1a; outline: none; transition: border-color 0.2s;
  }
  .ct-input:focus { border-color: #1a1a1a; }
  .ct-input::placeholder { color: #ccc; }
  .ct-select { appearance: none; cursor: pointer; }
  .ct-textarea { resize: vertical; min-height: 120px; }
  .ct-row { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
  .ct-submit-btn {
    width: 100%; font-family: 'Bebas Neue', monospace; font-size: 18px; letter-spacing: 0.14em;
    background: #1a1a1a; color: #fff; border: none; border-radius: 0;
    padding: 16px 32px; cursor: pointer; transition: background 0.2s;
    display: flex; align-items: center; justify-content: center; gap: 10px; margin-top: 8px;
  }
  .ct-submit-btn:hover { background: #1B2FE8; }
  .ct-submit-btn:disabled { opacity: 0.5; cursor: not-allowed; }
  .ct-spinner { width: 18px; height: 18px; border: 2px solid rgba(255,255,255,0.3); border-top-color: #fff; border-radius: 50%; animation: ct-spin 0.7s linear infinite; }
  @keyframes ct-spin { to{transform:rotate(360deg)} }

  /* success state */
  .ct-success {
    border: 1px solid #E8E4DC; background: #fff; padding: 40px 32px;
    text-align: center; display: flex; flex-direction: column; align-items: center; gap: 12px;
  }
  .ct-success-icon { font-size: 40px; }
  .ct-success-title { font-family: 'Bebas Neue', monospace; font-size: 36px; letter-spacing: 0.04em; color: #1a1a1a; }
  .ct-success-text { font-family: 'Space Mono', monospace; font-size: 10px; line-height: 2; color: #888; max-width: 280px; }

  /* map */
  .ct-map-side { display: flex; flex-direction: column; gap: 24px; }
  .ct-map-wrap {
    border: 1px solid #E8E4DC; overflow: hidden;
    box-shadow: 4px 4px 0 #1a1a1a;
  }
  .ct-map-wrap iframe { display: block; width: 100%; height: 340px; border: none; }
  .ct-map-info { border: 1px solid #E8E4DC; background: #fff; padding: 24px; }
  .ct-map-info-title { font-family: 'Bebas Neue', monospace; font-size: 20px; letter-spacing: 0.04em; color: #1a1a1a; margin-bottom: 12px; }
  .ct-map-info-line { font-family: 'Space Mono', monospace; font-size: 10px; line-height: 1.9; color: #888; }

  /* ── FAQ ── */
  .ct-faq-section {
    background: linear-gradient(160deg, #1C1C20 0%, #16161A 60%, #1A1620 100%);
    padding: 60px 40px;
    border-top: 1px solid rgba(255,214,0,0.1);
    position: relative; overflow: hidden;
  }
  .ct-faq-section::before {
    content: '';
    position: absolute; inset: 0;
    background-image: radial-gradient(circle, rgba(255,214,0,0.05) 1px, transparent 1px);
    background-size: 24px 24px;
    pointer-events: none;
  }
  .ct-faq-section::after {
    content: ''; position: absolute; inset: 0;
    background: radial-gradient(ellipse 50% 60% at 80% 40%, rgba(27,47,232,0.08) 0%, transparent 70%);
    pointer-events: none;
  }
  .ct-faq-inner { max-width: 800px; margin: 0 auto; position: relative; z-index: 1; }
  .ct-faq-eyebrow { font-family: 'Space Mono', monospace; font-size: 10px; font-weight: 700; letter-spacing: 0.3em; text-transform: uppercase; color: rgba(255,255,255,0.3); margin-bottom: 16px; }
  .ct-faq-title { font-family: 'Bebas Neue', monospace; font-size: clamp(36px,4vw,56px); letter-spacing: 0.02em; color: #fff; margin-bottom: 56px; line-height: 1; }
  .ct-faq-title em { color: #FFD600; font-style: normal; }
  .ct-faq-list { display: flex; flex-direction: column; }
  .ct-faq-item { border-top: 1px solid rgba(255,255,255,0.08); }
  .ct-faq-item:last-child { border-bottom: 1px solid rgba(255,255,255,0.08); }
  .ct-faq-q { width: 100%; background: none; border: none; padding: 20px 0; display: flex; align-items: center; gap: 16px; cursor: pointer; text-align: left; }
  .ct-faq-q-text { font-family: 'Bebas Neue', monospace; font-size: 20px; letter-spacing: 0.04em; color: rgba(255,255,255,0.8); flex: 1; }
  .ct-faq-item.open .ct-faq-q-text { color: #fff; }
  .ct-faq-icon { font-size: 16px; color: rgba(255,255,255,0.2); transition: transform 0.3s; flex-shrink: 0; font-family: 'Space Mono', monospace; }
  .ct-faq-item.open .ct-faq-icon { transform: rotate(45deg); color: #FFD600; }
  .ct-faq-body { max-height: 0; overflow: hidden; transition: max-height 0.4s cubic-bezier(.4,0,.2,1); }
  .ct-faq-item.open .ct-faq-body { max-height: 200px; }
  .ct-faq-answer { padding: 0 0 20px; font-family: 'Space Mono', monospace; font-size: 10px; line-height: 2; color: rgba(255,255,255,0.4); }

  /* ── FOOTER — identical to Courses/Blog/About ── */
  .ct-footer { background: #EDEAE2; padding: 48px 40px 36px; border-top: 1px solid #D8D4CC; }
  .ct-footer-inner { max-width: 1100px; margin: 0 auto; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 24px; }
  .ct-footer-brand { font-family: 'Bebas Neue', monospace; font-size: 24px; letter-spacing: 0.12em; color: #1a1a1a; }
  .ct-footer-links { display: flex; gap: 28px; }
  .ct-footer-link { font-family: 'Space Mono', monospace; font-size: 9px; font-weight: 700; letter-spacing: 0.18em; text-transform: uppercase; color: #888; text-decoration: none; transition: color 0.2s; }
  .ct-footer-link:hover { color: #1a1a1a; }
  .ct-footer-copy { font-family: 'Space Mono', monospace; font-size: 9px; letter-spacing: 0.12em; color: #aaa; text-transform: uppercase; }

  /* ── CONFETTI ── */
  .ct-confetti-piece {
    position: fixed; width: 8px; height: 8px; border-radius: 2px;
    pointer-events: none; z-index: 9999;
    animation: ct-fall linear forwards;
  }
  @keyframes ct-fall {
    0%   { transform: translateY(0) rotate(0deg) scale(1); opacity: 1; }
    100% { transform: translateY(100vh) rotate(720deg) scale(0.4); opacity: 0; }
  }

  /* ── REVEAL ── */
  .ct-reveal { opacity: 0; transform: translateY(24px); transition: opacity 0.65s ease, transform 0.65s ease; }
  .ct-reveal.visible { opacity: 1; transform: translateY(0); }
  .ct-reveal-d1 { transition-delay: 0.07s; }
  .ct-reveal-d2 { transition-delay: 0.14s; }
  .ct-reveal-d3 { transition-delay: 0.21s; }

  /* ── RESPONSIVE ── */
  @media (max-width: 960px) {
    .ct-hero-inner { grid-template-columns: 1fr; gap: 48px; }
    .ct-cards-grid { grid-template-columns: repeat(2,1fr); }
    .ct-form-inner { grid-template-columns: 1fr; }
    .ct-faq-inner { max-width: 100%; }
  }
  @media (max-width: 600px) {
    .ct-nav { padding: 0 20px; }
    .ct-nav-links { display: none; }
    .ct-hero { padding: 110px 20px 60px; }
    .ct-cards-section, .ct-form-section, .ct-faq-section { padding-left: 20px; padding-right: 20px; }
    .ct-cards-grid { grid-template-columns: 1fr 1fr; }
    .ct-row { grid-template-columns: 1fr; }
  }
`;

function injectStyle(id, css) {
  if (typeof document === 'undefined') return;
  if (document.getElementById(id)) return;
  const el = document.createElement('style');
  el.id = id; el.textContent = css;
  document.head.appendChild(el);
}

function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll('.ct-reveal');
    const io = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.06 }
    );
    els.forEach(el => io.observe(el));
    return () => io.disconnect();
  }, []);
}

const Wave = ({ top, bottom }) => (
  <div className="ct-wave" style={{ background: bottom }}>
    <svg viewBox="0 0 1440 60" preserveAspectRatio="none" style={{ height: 60 }}>
      <path d="M0,30 C360,60 1080,0 1440,30 L1440,0 L0,0 Z" fill={top} />
    </svg>
  </div>
);

/* ── Campaign Visual ── */
function CampaignVisual() {
  return (
    <div className="ct-camp-wrap">
      <div className="ct-camp-glow" />

      {/* outer orbit ring */}
      <div className="ct-orb-ring ct-orb-ring-b" />
      {/* inner orbit ring */}
      <div className="ct-orb-ring ct-orb-ring-a" />

      {/* inner ring orbiters — 3 icons evenly spaced */}
      {[{ icon:'🎯', delay:'0s' }, { icon:'📈', delay:'-8s' }, { icon:'💡', delay:'-16s' }].map((o, i) => (
        <div key={i} className="ct-ow-a" style={{ animationDelay: o.delay }}>
          <div className="ct-orb-chip" style={{ animationDelay: o.delay }}>{o.icon}</div>
        </div>
      ))}

      {/* outer ring orbiters — 2 icons */}
      {[{ icon:'📊', delay:'0s' }, { icon:'🚀', delay:'-16s' }].map((o, i) => (
        <div key={i} className="ct-ow-b" style={{ animationDelay: o.delay }}>
          <div className="ct-orb-chip-b" style={{ animationDelay: o.delay }}>{o.icon}</div>
        </div>
      ))}

      {/* pulsing gold dots */}
      <div className="ct-camp-dot ct-cd-1" />
      <div className="ct-camp-dot ct-cd-2" />
      <div className="ct-camp-dot ct-cd-3" />

      {/* central hub */}
      <div className="ct-camp-hub">
        <div className="ct-hub-icon">✉️</div>
        <div className="ct-hub-lbl">Reach Us</div>
      </div>

      {/* floating stat badges */}
      <div className="ct-camp-badge ct-cb-1">⚡ Reply in <b>2 min</b></div>
      <div className="ct-camp-badge ct-cb-2">🌍 <b>Global</b> Clients</div>
      <div className="ct-camp-badge ct-cb-3">✅ <b>94%</b> Satisfaction</div>
    </div>
  );
}

/* ── Confetti ── */
function launchConfetti() {
  const COLORS = ['#FFD600','#1B2FE8','#F9F7F4','#1a1a1a','#fff','rgba(255,214,0,0.6)'];
  for (let i = 0; i < 80; i++) {
    const el = document.createElement('div');
    el.className = 'ct-confetti-piece';
    el.style.left = `${Math.random() * 100}vw`;
    el.style.top = `-10px`;
    el.style.background = COLORS[Math.floor(Math.random() * COLORS.length)];
    el.style.animationDuration = `${0.9 + Math.random() * 1.4}s`;
    el.style.animationDelay = `${Math.random() * 0.5}s`;
    el.style.borderRadius = Math.random() > 0.5 ? '50%' : '2px';
    el.style.width = el.style.height = `${5 + Math.random() * 7}px`;
    document.body.appendChild(el);
    setTimeout(() => el.remove(), 2800);
  }
}

/* ── FAQ Item ── */
function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`ct-faq-item${open ? ' open' : ''}`}>
      <button className="ct-faq-q" onClick={() => setOpen(v => !v)}>
        <span className="ct-faq-q-text">{q}</span>
        <span className="ct-faq-icon">+</span>
      </button>
      <div className="ct-faq-body">
        <p className="ct-faq-answer">{a}</p>
      </div>
    </div>
  );
}

/* ─── DATA ─── */
const MARQUEE = [
  'Contact','Type Engineering','Support','Community','Discord','GitHub','Open Source',
  'Contact','Type Engineering','Support','Community','Discord','GitHub','Open Source',
];

const PILLS = [
  { icon: '✉', label: 'Email Support', value: 'hello@monospace.design' },
  { icon: '💬', label: 'Discord Community', value: 'discord.gg/monospace' },
  { icon: '🐙', label: 'GitHub', value: 'github.com/monospace-type' },
  { icon: '🕐', label: 'Response Time', value: 'Within 24 hours' },
];

const CARDS = [
  { icon: '✉', title: 'Email Us', value: 'hello@monospace.design', note: 'General enquiries and course support' },
  { icon: '💬', title: 'Discord', value: 'discord.gg/monospace', note: 'Live community & real-time help' },
  { icon: '🐙', title: 'GitHub', value: 'github/monospace-type', note: 'Open source tools and issues' },
  { icon: '🕐', title: 'Response', value: '< 24 hours', note: 'Mon–Fri · 9am – 6pm IST' },
];

const TOPICS = [
  'Course Access', 'Font Licensing', 'Technical Support',
  'Partnership', 'Press & Media', 'Other',
];

const FAQS = [
  { q: 'Do I get the source font files?', a: 'Yes — the Font Engineering and Monospace Type Design courses include full access to the working source files (Glyphs App format). You can use these for learning and your own non-commercial projects.' },
  { q: 'Can I use the fonts for commercial projects?', a: 'Fonts you design during the courses are yours to license however you choose. Any fonts we distribute as course materials are provided under a personal-use licence unless otherwise stated.' },
  { q: 'How do I access my courses after purchase?', a: 'Immediately after payment you receive a confirmation email with login credentials. All purchased courses are available under My Learning in your account dashboard.' },
  { q: 'Is there a team or studio licence?', a: 'Yes. Contact us directly for team pricing — we offer 5-seat and unlimited-seat bundles with a shared dashboard and onboarding support.' },
  { q: 'Do you offer refunds?', a: 'Yes — within 7 days of purchase if you have completed fewer than 20% of the course content. Contact us and we will process your refund within 2 business days.' },
  { q: 'Can I access courses on mobile?', a: 'Yes. All course content is fully responsive. The font engineering exercises work best on a desktop, but all video lessons and reading material work well on any device.' },
];

/* ─── MAIN ─── */
export default function Contact() {
  useEffect(() => { injectStyle('ct-styles', STYLE); }, []);
  useReveal();

  const [form, setForm] = useState({ name: '', email: '', topic: '', message: '' });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = e => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) return;
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSent(true);
      launchConfetti();
    }, 1200);
  };

  return (
    <div>

      {/* HERO — warm cream, light, attractive */}
      <section className="ct-hero">
        <div className="ct-hero-inner">
          <div className="ct-reveal">
            <p className="ct-hero-eyebrow">Get in Touch</p>
            <h1 className="ct-hero-title">
              Say<br /><em>Hello</em>
            </h1>
            <p className="ct-hero-desc">
              Questions about a course, font licensing, or just want to talk type?
              We read and reply to every message personally.
            </p>
            <div className="ct-hero-pills">
              {PILLS.map((p, i) => (
                <div className="ct-pill" key={i}>
                  <span className="ct-pill-icon">{p.icon}</span>
                  <div>
                    <div className="ct-pill-label">{p.label}</div>
                    <div className="ct-pill-value">{p.value}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Campaign Visual */}
          <div className="ct-reveal ct-reveal-d1">
            <CampaignVisual />
          </div>
        </div>
      </section>

      {/* MARQUEE */}
      <div className="ct-marquee-bar">
        <div className="ct-marquee-track">
          {MARQUEE.map((item, i) => (
            <span key={i} className="ct-mq-item">{item}<span className="ct-mq-dot" /></span>
          ))}
        </div>
      </div>

      <Wave top="#0E0E10" bottom="#F9F7F4" />

      {/* CONTACT CARDS */}
      <section className="ct-cards-section">
        <div className="ct-cards-inner">
          <div className="ct-cards-grid ct-reveal">
            {CARDS.map((c, i) => (
              <div className="ct-card" key={i}>
                <span className="ct-card-icon">{c.icon}</span>
                <div className="ct-card-title">{c.title}</div>
                <div className="ct-card-value">{c.value}</div>
                <div className="ct-card-note">{c.note}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FORM + MAP */}
      <section className="ct-form-section">
        <div className="ct-form-inner">

          {/* Form */}
          <div className="ct-reveal">
            <p className="ct-form-eyebrow">Send a Message</p>
            <h2 className="ct-form-title">Let's <em>Talk</em></h2>
            {sent ? (
              <div className="ct-success">
                <span className="ct-success-icon">✓</span>
                <div className="ct-success-title">Message Sent</div>
                <p className="ct-success-text">We'll get back to you within 24 hours. Check your inbox for a confirmation.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="ct-row">
                  <div className="ct-field">
                    <label className="ct-label">Name</label>
                    <input className="ct-input" type="text" name="name" placeholder="Your name" value={form.name} onChange={handleChange} required />
                  </div>
                  <div className="ct-field">
                    <label className="ct-label">Email</label>
                    <input className="ct-input" type="email" name="email" placeholder="you@email.com" value={form.email} onChange={handleChange} required />
                  </div>
                </div>
                <div className="ct-field">
                  <label className="ct-label">Topic</label>
                  <select className="ct-input ct-select" name="topic" value={form.topic} onChange={handleChange}>
                    <option value="">Select a topic...</option>
                    {TOPICS.map((t, i) => <option key={i} value={t}>{t}</option>)}
                  </select>
                </div>
                <div className="ct-field">
                  <label className="ct-label">Message</label>
                  <textarea className="ct-input ct-textarea" name="message" placeholder="Tell us what's on your mind..." value={form.message} onChange={handleChange} required />
                </div>
                <button className="ct-submit-btn" type="submit" disabled={loading}>
                  {loading ? <><div className="ct-spinner" /> Sending...</> : <>Send Message →</>}
                </button>
              </form>
            )}
          </div>

          {/* Map + Info */}
          <div className="ct-map-side ct-reveal ct-reveal-d1">
            <div className="ct-map-wrap">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d241317.11609823277!2d72.74109995709657!3d19.08252455!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c6306644edc1%3A0x5da4ed8f8d648c69!2sMumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
                allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"
                title="Monospace Location"
              />
            </div>
            <div className="ct-map-info">
              <div className="ct-map-info-title">Monospace HQ</div>
              <div className="ct-map-info-line">Mumbai, Maharashtra, India</div>
              <div className="ct-map-info-line" style={{ marginTop: 6 }}>Mon – Fri · 9:00 am – 6:00 pm IST</div>
              <div className="ct-map-info-line" style={{ marginTop: 6 }}>hello@monospace.design</div>
            </div>
          </div>
        </div>
      </section>

      <Wave top="#F9F7F4" bottom="#1C1C20" />

      {/* FAQ */}
      <section className="ct-faq-section">
        <div className="ct-faq-inner">
          <p className="ct-faq-eyebrow ct-reveal">Common Questions</p>
          <h2 className="ct-faq-title ct-reveal">FAQ <em>& Support</em></h2>
          <div className="ct-faq-list ct-reveal">
            {FAQS.map((f, i) => <FaqItem key={i} q={f.q} a={f.a} />)}
          </div>
        </div>
      </section>


    </div>
  );
}